import { useRef, useState } from "react";

import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface IPatientHistoryItemDeletePopupProps {
    onCancel: () => void;
    onDelete: () => void;
}

function PopulationBasedFundingPatientHistoryItemDeletePopup(props: IPatientHistoryItemDeletePopupProps): JSX.Element {
    const { getText } = useTranslation();
    const [hasDeleteButtonBeenClicked, setHasDeleteButtonBeenClicked] = useState(false);

    const isServerCallAlreadySent = useRef(false);

    const onDeleteButtonClicked = (): void => {
        if (!isServerCallAlreadySent.current) {
            isServerCallAlreadySent.current = true;
            props.onDelete();
        }

        setHasDeleteButtonBeenClicked(true);
    };

    function renderFooter(): JSX.Element {
        return (
            <div className="p-footer">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                        <div>
                            <button
                                data-action="cancel"
                                className="btn btn-default push-right-5"
                                onClick={props.onCancel}
                            >
                                {getText("CancelLabel")}
                            </button>
                            <button
                                data-action="ok"
                                className="btn btn-danger"
                                disabled={hasDeleteButtonBeenClicked}
                                onClick={onDeleteButtonClicked}
                            >
                                {getText("DeleteLabel")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Modal
            id="PopulationBasedFundingPatientHistoryEditWarningPopup"
            title={cacheStore.GetString("WarningLabel")}
            onClose={() => props.onCancel()}
            footer={renderFooter()}
            top={180}
            width={395}
            draggable
            showOverlay={true}
        >
            {getText("DeletePopulationBasedFundingEventLabel")}<br />
            {getText("ThisActionCannotBeUndoneLabel")}
        </Modal>
    );
}
export { PopulationBasedFundingPatientHistoryItemDeletePopup };
